var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ctm-payment-summary-settings" }, [
    _c(
      "div",
      { staticClass: "ctm-ps-row" },
      [
        _c("label", { staticClass: "ctm-ps-label" }, [
          _vm._v("Currency Symbol")
        ]),
        _vm._v(" "),
        _c("el-input", {
          staticStyle: { width: "80px" },
          attrs: { placeholder: "$" },
          model: {
            value: _vm.editfield.currency_symbol,
            callback: function($$v) {
              _vm.$set(_vm.editfield, "currency_symbol", $$v)
            },
            expression: "editfield.currency_symbol"
          }
        }),
        _vm._v(" "),
        _c(
          "el-select",
          {
            staticStyle: { width: "130px", "margin-left": "8px" },
            model: {
              value: _vm.editfield.currency_position,
              callback: function($$v) {
                _vm.$set(_vm.editfield, "currency_position", $$v)
              },
              expression: "editfield.currency_position"
            }
          },
          [
            _c("el-option", { attrs: { label: "Left  ($10)", value: "left" } }),
            _vm._v(" "),
            _c("el-option", { attrs: { label: "Right (10$)", value: "right" } })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ctm-ps-row" },
      [
        _c("label", { staticClass: "ctm-ps-label" }, [_vm._v("Tax Rate (%)")]),
        _vm._v(" "),
        _c("el-input-number", {
          staticStyle: { width: "120px" },
          attrs: {
            min: 0,
            max: 100,
            precision: 2,
            step: 1,
            "controls-position": "right"
          },
          model: {
            value: _vm.editfield.tax_rate,
            callback: function($$v) {
              _vm.$set(_vm.editfield, "tax_rate", $$v)
            },
            expression: "editfield.tax_rate"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "ctm-ps-hint" }, [
          _vm._v("Set to 0 to hide the tax row")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ctm-ps-row" },
      [
        _c("label", { staticClass: "ctm-ps-label" }, [
          _vm._v("Subtotal Label")
        ]),
        _vm._v(" "),
        _c("el-input", {
          staticStyle: { "max-width": "220px" },
          attrs: { placeholder: "Subtotal" },
          model: {
            value: _vm.editfield.subtotal_label,
            callback: function($$v) {
              _vm.$set(_vm.editfield, "subtotal_label", $$v)
            },
            expression: "editfield.subtotal_label"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ctm-ps-row" },
      [
        _c("label", { staticClass: "ctm-ps-label" }, [_vm._v("Tax Label")]),
        _vm._v(" "),
        _c("el-input", {
          staticStyle: { "max-width": "220px" },
          attrs: { placeholder: "Tax" },
          model: {
            value: _vm.editfield.tax_label,
            callback: function($$v) {
              _vm.$set(_vm.editfield, "tax_label", $$v)
            },
            expression: "editfield.tax_label"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ctm-ps-row" },
      [
        _c("label", { staticClass: "ctm-ps-label" }, [_vm._v("Total Label")]),
        _vm._v(" "),
        _c("el-input", {
          staticStyle: { "max-width": "220px" },
          attrs: { placeholder: "Total" },
          model: {
            value: _vm.editfield.total_label,
            callback: function($$v) {
              _vm.$set(_vm.editfield, "total_label", $$v)
            },
            expression: "editfield.total_label"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ctm-ps-row" },
      [
        _c("label", { staticClass: "ctm-ps-label" }, [_vm._v("Empty Message")]),
        _vm._v(" "),
        _c("el-input", {
          staticStyle: { "max-width": "300px" },
          attrs: { placeholder: "No items selected yet." },
          model: {
            value: _vm.editfield.empty_message,
            callback: function($$v) {
              _vm.$set(_vm.editfield, "empty_message", $$v)
            },
            expression: "editfield.empty_message"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "ctm-ps-hint" }, [
          _vm._v("Shown when no product fields are filled")
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }